<template>
    <div v-if="visible" class="custom-menu" @click.stop>
        <div class="menu-wrapper" @click="handleAction">
            <InlineSvg
                class="icon"
                :src="loadFile(`whatsapp/mark-unread.svg`)"
            />
            <p class="txt">{{$t(contact?.last_message?.is_new ? 'make-as-read' : 'make-as-unread')}}</p>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, computed } from 'vue';
import {doc, updateDoc} from "firebase/firestore";
import { db } from "@/firebase";
import InlineSvg from '@/v2/components/inline-svg';
import { loadFile } from '@/components/utils.js';

const emit = defineEmits(["set-active-menu"]);

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
    activeMenu: String,
    tenant: String
});

const visible = computed(() => {
    return props.activeMenu === props.contact?.id;
});

onMounted(() => {
    document.addEventListener('click', hideMenu);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', hideMenu);
});

const showMenu = (event) => {
    // if(!props?.contact?.last_message?.is_new)
        emit('set-active-menu', props.contact?.id);
};

const hideMenu = ()=> {
    emit('set-active-menu', null);
};

const handleAction = ()=> {
    makeMessageUnRead();
    hideMenu();
};

const makeMessageUnRead = ()=> {
    const conversationRef = doc(
        db,
        `tenants/${props.tenant}/conversations`,
        props.contact?.id
    );
    updateDoc(conversationRef, {
        "last_message.is_new": !props?.contact?.last_message?.is_new,
    });
};

defineExpose({
    showMenu,
});
</script>

<style scoped lang="scss">
    .custom-menu {
        position: absolute;
        background-color: white;
        border: 1px solid #EAECF0;
        box-shadow: 0px 4px 12px 0px #0000003D;
        border-radius: 8px;
        z-index: 1000;
        .menu-wrapper{
            display: flex;
            gap: 10px;
            padding: 16px;
            align-items: center;
            .txt{
                font-size: 14px;
                font-weight: 500;
                color: #0C111D;
                margin-bottom: 0;
            }
        }
    }
</style>
